import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import TextSkeleton from 'components/text-skeleton';

const SkeletonSearchTeaser = ({ className }) => {
  return (
    <div
      className={cn('skeleton-search-teaser', {
        [className]: className,
      })}
    >
      <div className="skeleton-search-teaser__image-holder"></div>
      <div className="skeleton-search-teaser__content">
        <div className="skeleton-search-teaser__heading-holder">
          <TextSkeleton
            className="skeleton-search-teaser__heading-skeleton"
            lineClassName="skeleton-search-teaser__heading-skeleton-line"
            maxLines={4}
          />
        </div>
      </div>
    </div>
  );
};

SkeletonSearchTeaser.propTypes = {
  className: PropTypes.string,
};

SkeletonSearchTeaser.viewModelMeta = 'ignore';

export default SkeletonSearchTeaser;
